export const USERS = {
        adminPage: 'admin-users-page',
        row: 'admin-user-row',
        editBtn: 'admin-user-edit',
        resetBtn: 'admin-user-reset',
        saveBtn: 'admin-user-save',
        resetSaveBtn: 'admin-user-reset-save',
};

export const PROFILE = {
        page: 'profile-page',
        fullName: 'profile-full-name',
        phone: 'profile-phone',
        saveBtn: 'profile-save',
        currentPw: 'profile-current-password',
        newPw: 'profile-new-password',
        confirmPw: 'profile-confirm-password',
        changePwBtn: 'profile-change-password',
};
